import React, { useRef, useState } from "react";
import ReactFlagsSelect from "react-flags-select";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "../style/checkout.scss";
import Payment from "./common/Payment";

const money = (value) => `$${value.toFixed(2)}`;

export default function Checkout({ items, onNavigate }) {
  const paymentRef = useRef(null);
  const [country, setCountry] = useState("US");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const subtotal = items.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0,
  );
  const shipping = items.length && subtotal < 75 ? 8 : 0;

  const submit = (event) => {
    event.preventDefault();
    if (!items.length)
      return setMessage(
        "Your bag is empty. Add a product before checking out.",
      );
    if (!paymentRef.current?.getPaymentVaild())
      return setMessage(
        "Please check your card number, expiry date and security code.",
      );
    setMessage(
      "Your checkout details are complete. Payment submission is disabled in this demo.",
    );
  };

  return (
    <main className="checkout-page">
      <header className="head">
        <div className="head-content">
          <button
            className="logo"
            type="button"
            onClick={() => onNavigate("home")}
            aria-label="VARSENIC home"
          >
            <img src="/varsenic-logo.svg" alt="VARSENIC" />
          </button>
          <button
            className="icon"
            type="button"
            onClick={() => onNavigate("cart")}
          >
            Back to bag
          </button>
        </div>
      </header>
      <div className="check-body">
        <section className="left">
          <form className="form-box" onSubmit={submit}>
            <h1 className="title">Contact</h1>
            <input
              type="email"
              name="email"
              autoComplete="email"
              required
              placeholder="Email address"
            />
            <h2 className="title">Delivery address</h2>
            <ReactFlagsSelect
              selected={country}
              onSelect={setCountry}
              searchable
              searchPlaceholder="Search countries"
            />
            <div className="row">
              <div className="half">
                <input
                  name="firstName"
                  autoComplete="given-name"
                  required
                  placeholder="First name"
                />
              </div>
              <div className="half">
                <input
                  name="lastName"
                  autoComplete="family-name"
                  required
                  placeholder="Last name"
                />
              </div>
            </div>
            <input
              name="address"
              autoComplete="street-address"
              required
              placeholder="Address"
            />
            <input
              name="apartment"
              autoComplete="address-line2"
              placeholder="Apartment, suite, etc. (optional)"
            />
            <div className="row">
              <div className="half">
                <input
                  name="city"
                  autoComplete="address-level2"
                  required
                  placeholder="City"
                />
              </div>
              <div className="half">
                <input
                  name="postalCode"
                  autoComplete="postal-code"
                  required
                  placeholder="Postal code"
                />
              </div>
            </div>
            <PhoneInput
              country={country.toLowerCase()}
              value={phone}
              onChange={setPhone}
              inputProps={{
                name: "phone",
                autoComplete: "tel",
                required: true,
              }}
            />
            <Payment ref={paymentRef} />
            {message && (
              <p className="tip" role="status">
                {message}
              </p>
            )}
            <button className="btn" type="submit">
              Complete order
            </button>
            <p className="policy">
              By continuing, you agree to VARSENIC’s shipping, returns, privacy
              and payment policies.
            </p>
          </form>
        </section>
        <aside className="right">
          <div className="info-box">
            {items.map((item) => (
              <article className="tab-li" key={item.key || item.id}>
                <div className="l">
                  <div className="img-box">
                    <img src={item.images[0]} alt={item.title} />
                    <span className="num">{item.quantity}</span>
                  </div>
                  <div className="name">
                    <b>{item.title}</b>
                    <small>{item.size}</small>
                  </div>
                </div>
                <span className="total">
                  {money(item.price * item.quantity)}
                </span>
              </article>
            ))}
            <div className="subtotal">
              <span>Subtotal</span>
              <span className="price">{money(subtotal)}</span>
            </div>
            <div className="shipping">
              <span>Shipping</span>
              <span>{shipping ? money(shipping) : "Complimentary"}</span>
            </div>
            <div className="total-row">
              <span>Total</span>
              <span className="price">
                <span>USD </span>
                {money(subtotal + shipping)}
              </span>
            </div>
            <p className="policy">
              Your payment details are validated locally for this demonstration
              and are not transmitted or stored.
            </p>
          </div>
        </aside>
      </div>
    </main>
  );
}
